import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
export function Card({
  children,
  className = ''
}: CardProps) {
  return <div className={`bg-white rounded-xl shadow-xl border border-slate-100 overflow-hidden ${className}`} data-id="element-242">
      {children}
    </div>;
}